import cookie from 'js/lib/cookie';

import DegreesExperiments from 'bundles/epic/clients/Degrees';
import FullStoryExperiments from 'bundles/epic/clients/FullStory';

import {
  degreeAndLearnerArePartOfV3ControlGroup,
  degreeIsPartOfV3Experiment,
} from '../components/v3-dpm/lib/experiments';

export const isFullStoryEnabled = () => FullStoryExperiments.get('enableFullstoryOnDegreeHome');

const DEGREE_HOME_V2_OPT_OUT_COOKIE_NAME = 'degreehome_showv1';
export const hasDegreeHomeV2OptOutCookie = (): boolean => cookie.get(DEGREE_HOME_V2_OPT_OUT_COOKIE_NAME) != null;
export const setDegreeHomeV2OptOutCookie = (): string =>
  cookie.set(DEGREE_HOME_V2_OPT_OUT_COOKIE_NAME, true, { days: 180 });
export const removeDegreeHomeV2OptOutCookie = (): void => cookie.remove(DEGREE_HOME_V2_OPT_OUT_COOKIE_NAME);

export const isDegreeHomeV2EpicEnabled = (degreeSlug: string) => {
  const parameterValue = DegreesExperiments.get('showDegreeHomeV2');
  return (
    parameterValue?.enabled &&
    parameterValue?.excludedDegreeSlugs &&
    !parameterValue.excludedDegreeSlugs.includes(degreeSlug)
  );
};

export const showDegreeV2NavButtons = (degreeSlug: string | undefined) => {
  if (!degreeSlug) {
    return false;
  }

  if (degreeIsPartOfV3Experiment(degreeSlug)) {
    return false;
  }

  return isDegreeHomeV2EpicEnabled(degreeSlug);
};

export const isDegreeHomeV2Enabled = (degreeSlug: string | undefined) => {
  if (!degreeSlug) {
    return false;
  }

  if (degreeAndLearnerArePartOfV3ControlGroup(degreeSlug)) {
    return true;
  }

  return !hasDegreeHomeV2OptOutCookie() && isDegreeHomeV2EpicEnabled(degreeSlug);
};

export const isStudentHomeV2Beta1Enabled = () => DegreesExperiments.get('showStudentHomeV2Beta1');
export const isDismissOverdueItemsEnabled = () => DegreesExperiments.get('enableDismissOverdueItems');
export const isImprovedCertEnrollmentsEnabled = () => DegreesExperiments.get('showImprovedCertEnrollments');
